import { render, staticRenderFns } from "./LeavePageDetailsTable.vue?vue&type=template&id=aaa731f6&scoped=true&"
import script from "./LeavePageDetailsTable.vue?vue&type=script&lang=js&"
export * from "./LeavePageDetailsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaa731f6",
  null
  
)

export default component.exports